<div class="popup-background" (click)="closePopup()" [ngStyle]="{'visibility': display? 'visible': 'hidden'}">
    <div class="popup-box" (click)="$event.stopPropagation()" [ngClass]="{'high-contrast': highContrast}">
        <img src="assets/common/close.svg" class="icon close-icon" alt="close icon" (click)="closePopup()">
        <div class="title-container">
            <img src="assets/common/exclamation.svg" alt="exclamation icon" class="exclamation-icon">
            <h2 class="text-center title">Consulta pública</h2>
        </div>
        <p class="text-justify text">
            A <b>versão preliminar atualizada do Catálogo Nacional de Cursos Superiores de Tecnologia (CNCST)</b>
            está disponível para consulta e os interessados poderão enviar sugestões para o seu aprimoramento até o dia <b>25 de março de 2022.</b> 
            Como a nova versão será disponibilizada de forma digital, também serão aceitas contribuições para a Plataforma.
        </p>
        <button class="btn rounded-pill btn-primary" (click)="closePopup()" routerLink="/aviso-sugestao">
            Consulta pública do CNCST
        </button>

        <p class="text-justify text">
            Também estão em consulta as <b>áreas tecnológicas</b> propostas para cada eixo tecnológico. Você pode opinar sobre as áreas propostas e suas descrições, bem como sobre o enquadramento dos cursos técnicos ou superiores de tecnologia em cada uma delas.
        </p>
        <button class="btn rounded-pill btn-primary" (click)="closePopup()" routerLink="/aviso-sugestao-areas">
            Consulta áreas tecnológicas
        </button>

        <p class="text-justify text">
            Neste mesmo período, é possível enviar sugestões para as <b>cargas horárias mínimas presenciais</b> para os cursos que compõem o <b>Catálogo Nacional de Cursos Técnicos (CNCT)</b>.
        </p>
        <button class="btn rounded-pill btn-primary" (click)="closePopup()" routerLink="/aviso-sugestao-cnct">
            Consulta cargas horárias CNCT
        </button>
    </div>
</div>